export enum VectorItemPanels {
  NONE = 'none',
  OUTLINE = 'outline',
  COLOR_FILL = 'color-fill',
  CUSTOM_SHADOW = 'custom-shadow',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
